<script>
import Constants from '../constants';
import simpleLoading from '@/components/simpleLoading';

export default {
  name: 'vueInstagram',
  components: {
    simpleLoading,
  },
  props: {
    posts: {
      type: Array,
      required: true,
    },
    showFollowBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ready: false,
      instagramUserUrl: Constants.SNS.INSTAGRAM,
      instagrumUrl: '',
      instagramScriptDom: null,
    };
  },
  beforeDestroy () {
    if (window.instgrm) { // https://qiita.com/kai-ono/items/48cadf3d8ed3ae9effdd
      delete window.instgrm;
    }
    if (this.instagramScriptDom) {
      this.$el.removeChild(this.instagramScriptDom);
    }
  },
  created() {
    this.instagrumUrl = this.posts[Math.floor(Math.random() * this.posts.length)];
    setTimeout(()=> {
      this.ready = true;

      setTimeout(()=> {
        this.instagramScriptDom = document.createElement('script');
        this.instagramScriptDom.async = this.instagramScriptDom.defer = true;
        this.instagramScriptDom.src = 'https://www.instagram.com/embed.js';
        this.$el.appendChild(this.instagramScriptDom);
        setTimeout(()=> {
          if (window.instgrm) {
            window.instgrm.Embeds.process();
          }
          setTimeout(()=> {
            // ヘッダーの下あたりまでスクロール
            this.$refs.instagrumEmbed.scroll({
              top: 54,
              left: 0,
            });
          }, 1000);
        }, 100);
      }, 100);

    }, 1001);
  },
};
</script>

<template>
  <div class="instagrum-container" v-if="ready">
    <div class="instagrum-embed" ref="instagrumEmbed">

      <blockquote class="instagram-media instagram-media-now-loading"
        data-instgrm-captioned
        :data-instgrm-permalink="`https://www.instagram.com/p/${instagrumUrl}/?utm_source=ig_embed&amp;utm_campaign=loading`"
        data-instgrm-version="13"
      >
        <div class="now-loading">
            <div class="loading">
              <div class="warn-text">{{$t('message.information.snsWarning') }}</div>
              <simple-loading/>
            </div>
            <div class="text">
              <a class="is-link"
                :href="`https://www.instagram.com/p/${instagrumUrl}/?utm_source=ig_embed&amp;utm_campaign=loading`"
                target="_blank"
              >
                {{$t('message.snsName.openInstagram')}}
              </a>
            </div>
        </div>
      </blockquote>
    </div>
    <a v-if="showFollowBtn"
      class="follow-me-btn"
      :title="$t('message.snsName.instagram')"
      target="_blank"
      :href="instagramUserUrl"
    ></a>
  </div>
</template>

<style lang="scss" >
  @import "../css/variables";
  .instagrum-container {
    position: relative;
    width: 100%;
    height: 100%;
    .instagrum-embed {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      position: relative;
      .now-loading {
        @include absolute100;
        .loading {
          @include absolute100;
          .warn-text {
            position: absolute;
            bottom: 25%;
            font-size: 0.8em;
          }
        }
        .text {
          font-size: 0.8em;
        }
        .is-link {
          &:hover {
            color: $accentColor2;
          }
        }
      }
      iframe {
        // margin-top: -50px!important;
        border-radius: 0px!important;
        border: none!important;
        max-width:100%!important;
        min-width:100%!important;
      }
    }
    .follow-me-btn {
      z-index: $zIndexFollowMeBtn;
      position: absolute;
      bottom: -35px;
      left: 0px;
      display: block;
      width: 110px;
      height: 70px;
      @include bgCenter;
      background-image: url(../assets/img/sns/followInstagram.svg);
      cursor: pointer;
      transition: 0.1s ease-out;
      &:hover {
        transform: translateY(-10px);
      }
    }
    
  }
</style>
